import { c as _c } from "react/compiler-runtime";
import { Badge, Flex, Separator, Timeline, TimelineAvatar, TimelineContent, TimelineItem, TimelineSide, TimelineTitle } from "@opensea/ui-kit";
import { DoNotDisturbOn, ErrorFilled } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { Button } from "../Button";
export const ActionTimelineError = t0 => {
  const $ = _c(11);
  const {
    message,
    onRetry,
    onBack,
    showSide: t1
  } = t0;
  const showSide = t1 === undefined ? true : t1;
  const t = useTranslations("wallet.ActionTimelineError");
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TimelineAvatar icon={DoNotDisturbOn} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== message) {
    t3 = <TimelineContent><TimelineTitle>{message}</TimelineTitle></TimelineContent>;
    $[1] = message;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onBack || $[4] !== onRetry || $[5] !== showSide || $[6] !== t) {
    t4 = showSide && <TimelineSide><Flex className="gap-3"><Badge icon={ErrorFilled} variant="error">{t("error")}</Badge><Separator className="h-6" orientation="vertical" />{onBack ? <Button onClick={onBack} size="sm" variant="secondary">{t("reset")}</Button> : null}{onRetry ? <Button onClick={() => onRetry()} size="sm">{t("retry")}</Button> : null}</Flex></TimelineSide>;
    $[3] = onBack;
    $[4] = onRetry;
    $[5] = showSide;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <Timeline><TimelineItem active={true}>{t2}{t3}{t4}</TimelineItem></Timeline>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};